import { FC } from 'react';

import type { INewWalletQuery, TWalletType } from '@entities/wallets';
import { useCreateWalletMutation } from '@entities/wallets';
import { ModalNewEntity } from '@features/modal-entity-new';

import { useWalletCreate } from './useWalletCreate';

interface IProps {
  type: TWalletType;
  refetch: () => void;
}

export const NewWallet: FC<IProps> = ({ type, refetch }) => {
  const { handleCreateWallet, handleSuccess, tagsRef } = useWalletCreate(refetch);

  const baseWalletKeys: (keyof INewWalletQuery)[] = [
    'type',
    'provider_id',
    'bank_id',
    'name',
    'wallet_address',
    'bank_code',
    'holder_name',
    'bank_account_number',
    'tags',
  ];

  const getNewWalletKeys = (): (keyof INewWalletQuery)[] => {
    switch (type) {
      case 'settlement':
        return ['merchant_id', 'mid_id', 'provider_id', 'type'];
      case 'withdraw':
        return [...baseWalletKeys, 'login_credentials_json'];
      case 'deposit':
        return [...baseWalletKeys, 'kind'];
      default:
        return baseWalletKeys;
    }
  };

  const newWalletKeys = getNewWalletKeys();

  const renamedLabels = {
    bank_id: 'Bank',
    provider_id: 'Provider',
    mid_id: 'MID',
    merchant_id: 'Merchant',
    bank_account_number: 'Bank Account Number',
  };

  return (
    <ModalNewEntity
      title='New Wallet'
      submitBtnText='Continue'
      entityKeys={newWalletKeys}
      renamedLabels={renamedLabels}
      useCreateEntityMutation={useCreateWalletMutation}
      onTransformFormData={handleCreateWallet}
      onSuccess={handleSuccess}
      otherProps={{ type, tagsRef }}
      keysOrder={
        type === 'withdraw' ? [...baseWalletKeys, 'login_credentials_json'] : baseWalletKeys
      }
    />
  );
};
